import type { FeedLink, FeedLinkPage } from "@/generated/api/types.gen"

export type { FeedLink }

export type LinkKind = FeedLink["kind"]

export type PageTarget = FeedLinkPage["page"]

export const LINK_KINDS = ["CATEGORY", "COLLECTION", "PRODUCT", "SEARCH", "PAGE", "EXTERNAL"] as const satisfies readonly LinkKind[]

export const PAGE_TARGETS = ["HELP", "SELL_WITH_NELO", "HOW_IT_WORKS", "CATEGORIES", "REFERRALS"] as const satisfies readonly PageTarget[]

export const isKnownLinkKind = (kind: string): kind is LinkKind => (LINK_KINDS as readonly string[]).includes(kind)
